const InvoiceSearchFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RCustomer",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Customer:",
                "type": "select",
                "options": [""],
                "apiUrl": "om/SaleOrder/GetCustomers",
                "grid": null,
                "required": false,
                "visible": true

            } ,
            {
                "name": "ReferenceNumber",
                "tableName": "",
                "label": "Reference Number",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "CustomerName",
                "tableName": "",
                "label": "Customer Name",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            } ,
            {
                "name": "Frequence",
                "tableName": "",
                "label": "Frequence",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "InvoiceNumber",
                "tableName": "",
                "label": "Invoice Number",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            } 

        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "InvoiceDate",
                "tableName": "",
                "label": "Invoice Date",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            }

        ]
    }
];
export default InvoiceSearchFormLayout;